import React from 'react';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import Img from '../../../../../../../components/Img/Img';
import Modal from '../../../../../../../components/Modal/Modal';
import { WidgetLayoutModalWrapperStyle } from './style';

interface WidgetLayoutSelectModalProps {
  title: string;
  img: string;
  isFirstItem: boolean;
  isLastItem: boolean;
  okText: string;
  onOk: () => void;
  onClose: () => void;
  onNext: () => void;
  onPrev: () => void;
}
const WidgetLayoutSelectModal = (props: WidgetLayoutSelectModalProps) => {
  const { title, img, isFirstItem, isLastItem, okText, onOk, onClose, onNext, onPrev } = props;
  return (
    <Modal
      title={title}
      isOpen={true}
      width={420}
      height={600}
      overflow={'hidden'}
      isFooter={true}
      okText={okText}
      onOk={onOk}
      onClose={onClose}
    >
      <WidgetLayoutModalWrapperStyle>
        <div className="control-manual-info">
          {!isFirstItem && <LeftOutlined className="prev" onClick={onPrev} />}

          {!isLastItem && <RightOutlined className="next" onClick={onNext} />}
        </div>

        <div className="img-wrap">
          <Img src={img} />
        </div>
      </WidgetLayoutModalWrapperStyle>
    </Modal>
  );
};

export default WidgetLayoutSelectModal;
